<template>
  <modal
    :title="
      setModel != undefined ? 'Update Notifications' : 'Add Notifications'
    "
    @close="$emit('close')"
    size="xl"
  >
    <template #content>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="financeType floating-labels p-10 p-b-0 border-bottom m-b-0"
        ref="form2"
        v-if="softwares != null && providers != null && customers != null"
      >
        <formGroup
          title="Subject"
          :errors="errors"
          v-model="saveModel.Subject"
          :rules="{ required: true }"
        ></formGroup>
        <div
          class="form-group"
          :class="{
            'has-error': errors['Body'] != undefined,
            focused:
              saveModel.Body != '' && saveModel.Body != null ? true : false,
          }"
        >
          <Field
            :as="'textarea'"
            :name="'Body'"
            id="Body"
            class="form-control"
            v-model="saveModel.Body"
            :class="{ 'parsley-error': errors['Body'] != undefined }"
            :rules="{ required: true }"
            style="appearance:auto;resize:auto;"
            resize="resize"
            rows="4"
          />
          <label class="control-label" :for="'Body'">Body </label>
          <ErrorMessage
            as="span"
            class="form-control-feedback small"
            :name="'Body'"
          />
        </div>
        <formGroup
          :title="'Aktif'"
          as="checkbox"
          v-model="saveModel.Active"
          @keydown.enter="save"
        ></formGroup>
      </Form>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="financeType floating-labels p-10 row p-b-0"
        ref="form"
        v-if="softwares != null && providers != null && customers != null"
      >
        <div class="col">
          <formGroup
            title="Software"
            :as="'select'"
            :errors="errors"
            v-model="model.SoftwareId"
          >
            <template #input>
              <option :value="null">Hepsi</option>
              <option
                :value="item.Id"
                v-for="item in softwares"
                :key="item.Name"
                >{{ item.Name }}</option
              >
            </template>
          </formGroup>
        </div>
        <div class="col">
          <formGroup
            title="Provider"
            :as="'select'"
            :errors="errors"
            v-model="model.ProviderId"
          >
            <template #input>
              <option :value="null">Hepsi</option>
              <option
                :value="item.Id"
                v-for="item in providers"
                :key="item.Name"
                >{{ item.Name }}</option
              >
            </template>
          </formGroup>
        </div>
        <div class="col">
          <formGroup
            title="Customer"
            :as="'select'"
            :errors="errors"
            v-model="model.CustomerId"
          >
            <template #input>
              <option :value="null">Hepsi</option>
              <option
                :value="item.Id"
                v-for="item in customers"
                :key="item.Name"
                >{{ item.Name }}</option
              >
            </template>
          </formGroup>
        </div>
        <div class="col-auto">
          <Btn class="btn-success" @click="get" :process="load">Search</Btn>
        </div>
      </Form>
      <load-area
        v-if="softwares == null || providers == null || customers == null"
      ></load-area>
      <div class="p-10 p-t-0" v-if="currentNotifications != null">
        <div class="alert alert-warning m-0">
          Bildirimi
          <strong>{{ currentNotifications.Users.length }}</strong> kullanıcıdan
          <strong>{{
            currentNotifications.Users.filter((x) => {
              return x.SawDate != null;
            }).length
          }}</strong>
          kullanıcı gördü.
        </div>
      </div>
      <div class="list" v-if="!load">
        <div class="myCheckBox">
          <input
            type="checkbox"
            class="filled-in"
            v-model="selectAll"
            @change="selectAllClick"
            id="chckMassConfirmable"
          /><label for="chckMassConfirmable"></label>
        </div>
        <dataTable
          :name="'ADDNOTIFICATIONS'"
          ref="agGrid"
          :data="
            data.sort((x) => {
              return x.SawDate == null ? 0 : 1;
            })
          "
          :columnDefs="columnDefs"
          @cellClicked="clickedCellRezGrid"
          :rowClassRules="{
            // row style function
            success: (params) => {
              // var numSickDays = params.data;
              return params?.data?.SawDate != null;
            },
          }"
        ></dataTable>
      </div>
      <!-- <Form method="dialog" v-slot="{ errors }" class="floating-labels p-1rem" ref="form">
                <formGroup :title="'Name'" v-model="model.Name" :errors="errors" :rules="{required:true,max:50}" @keydown.enter="save"></formGroup>
                <formGroup :title="'P1Name'" v-model="model.P1Name" :errors="errors" :rules="{max:100}" @keydown.enter="save"></formGroup>
                <formGroup :title="'P2Name'" v-model="model.P2Name" :errors="errors" :rules="{max:100}" @keydown.enter="save"></formGroup>
                <formGroup :title="'P3Name'" v-model="model.P3Name" :errors="errors" :rules="{max:100}" @keydown.enter="save"></formGroup>
                <formGroup :title="'P4Name'" v-model="model.P4Name" :errors="errors" :rules="{max:100}" @keydown.enter="save"></formGroup>
                <formGroup :title="'P5Name'" v-model="model.P5Name" :errors="errors" :rules="{max:100}" @keydown.enter="save"></formGroup>
            </Form> -->
    </template>
    <template v-if="!load" #foot>
      <Btn class="btn-success btn-md" @click="save" :process="process">{{
        setModel != undefined ? "Update Notifications" : "Add Notifications"
      }}</Btn>
    </template>
  </modal>
</template>

<script>
import moment from "moment";
export default {
  name: "Upsert",
  props: ["setModel"],
  data() {
    return {
      saveModel: {
        Id: null,
        Subject: "",
        Body: "",
        Active: true,
        Users: [],
      },
      columnDefs: [
        {
          headerName: "",
          width: 40,
          filter: false,
          field: "selected",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          floatingFilter: false,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "CustomerName",
          field: "CustomerName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Email",
          field: "Email",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "SawDate",
          field: "SawDate",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 140,
          valueFormatter: function(params) {
            if (params.value == null) {
              return null;
            } else {
              return moment(new Date(params.value)).format("DD.MM.YYYY HH:mm");
            }
          },
        },
        {
          headerName: "SoftwareName",
          field: "SoftwareName",
          enableRowGroup: true,
          filter: true,
          width: 140,
        },
      ],
      data: null,
      model: {
        SoftwareId: null,
        ProviderId: null,
        CustomerId: null,
      },
      softwares: null,
      providers: null,
      customers: null,
      load: true,
      selectAll: false,
      process: false,
      currentNotifications: null,
    };
  },
  created() {
    if (this.setModel != undefined) {
      this.$appAxiosAdmin
        .get(`Notifications/` + this.setModel.Id)
        .then((response) => {
          this.saveModel = {
            Id: response.data.Id,
            Subject: response.data.Subject,
            Body: response.data.Body,
            Active: response.data.Active,
            Users: [],
          };
          response.data.Users.forEach((element) => {
            this.saveModel.Users.push(element.UserId);
          });
          this.currentNotifications = response.data;
          this.create();
        })
        .catch((err) => {
          this.$isError(err);
          this.load = false;
        });
    } else {
      this.create();
    }
  },
  methods: {
    create() {
      this.$appAxiosAdmin.get(`Softwares`).then((response) => {
        this.softwares = response.data;
      });
      this.$appAxiosAdmin.get(`kolayrez/Providers`).then((response) => {
        this.providers = response.data;
      });
      // this.$appAxiosAdmin.get(`Customers`).then((response) => {
      this.$appAxiosAdmin.get(`CustomersNames`).then((response) => {
        this.customers = response.data;
      });
      this.get();
    },
    get() {
      this.load = true;
      this.selectAll = false;
      this.saveModel.Users = [];
      this.$appAxiosAdmin
        .post(`Users/SearchForNotification`, this.model)
        .then((response) => {
          let data = [];
          response.data.forEach((element) => {
            data.push({
              ...element,
              selected:
                this.saveModel.Users.indexOf(element.UserId) > -1
                  ? true
                  : false,
              SawDate:
                this.currentNotifications == null
                  ? null
                  : this.currentNotifications.Users.filter((x) => {
                      return x.UserId == element.UserId;
                    }).length > 0
                  ? this.currentNotifications.Users.filter((x) => {
                      return x.UserId == element.UserId;
                    })[0].SawDate
                  : null,
            });
          });
          this.data = data.sort((x) => {
            return x.SawDate == null ? 1 : -1;
          });
          this.load = false;
        })
        .catch((err) => {
          this.$isError(err);
          this.load = false;
        });
    },
    selectAllClick() {
      for (
        let index = 0;
        index < this.$refs.agGrid.gridApi.getDisplayedRowCount();
        index++
      ) {
        if (this.selectAll) {
          this.$refs.agGrid.changeRow("UserId", {
            ...this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(index).data,
            selected: true,
          });
        } else {
          this.$refs.agGrid.changeRow("UserId", {
            ...this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(index).data,
            selected: false,
          });
        }
      }
      console.log("this.data",this.data.length,this.data.filter(x=>x.selected).length);
    },
    clickedCellRezGrid(params) {
      this.$refs.agGrid.changeRow("UserId", {
        ...params.data,
        selected: !params.data.selected,
      });
    },
    save() {
      this.$refs.form2.validate().then((valid) => {
        if (valid.valid) {
          this.saveModel.Users = [];
          for (
            let index = 0;
            index < this.$refs.agGrid.gridApi.getDisplayedRowCount();
            index++
          ) {
            if (
              this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(index).data
                .selected
            ) {
              this.saveModel.Users.push(
                this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(index).data
                  .UserId
              );
            }
          }
          if (this.saveModel.Users.length == 0) {
            this.$swal({
              icon: "warning",
              title: "Warning",
              text: "Please select at least one user!",
              timer: 2000,
              confirmButtonText: "Okey",
            });
            return false;
          }
          this.process = true;
          this.$appAxiosAdmin
            .post(`Notifications/Upsert`, this.saveModel)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "Notifications has been successfully updated."
                    : "Notifications has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              this.$emit(this.setModel != undefined ? "Update" : "add", {
                ...response.data,
                UserCount: response.data.Users.length,
              });
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.list {
  position: relative;
}
.list .myCheckBox {
  position: absolute;
  left: 5px;
  top: 47px;
  z-index: 5;
}
</style>
